
export default {
  name: 'ContentCardParagraph',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true,
      default: ''
    }
  }
}
